export default class TranslationsInsertUpdateViewModel {
  translationKey: string;
  translationGroup: string;
  cargoKeepApplicationEnum: string;
  translations: any;
}
